var $ = global.jQuery = global.$;
var mapConfig = require('config').maps;

var LocMap = require('./LocMap');

/**
 * Locations small map (on home page)
 * @class
 * @extends LocMap
 */
var LocMapMini = LocMap.extend(
  /** @lends LocMapMini.prototype */
  {
  /**
   * Runs when then map is loaded using the google map loader in the _Map base.
   * @param {object} google The google instance that is passed through by the google map loader in the _Map init() method
   */
  onMapLoaded: function(google) {

    // Call the LocMap onMapLoaded() method
    this._super(google);

    // Move the map zoom control to the to right position so as not to conflict with the filters
    this.map.setOptions({
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP
      }
    });

  }
});

module.exports = LocMapMini;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/LocMapMini.js
 ** module id = 159
 ** module chunks = 0 1
 **/